<template>
  <div class="footer">
    <p>© Copyright 2021 <strong class="name">sujeong.k</strong></p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.name {
  font-weight: normal;
  color: #40c057;
}
</style>
